import { render } from "./CreateListAction.vue?vue&type=template&id=279bf80a"
import script from "./CreateListAction.vue?vue&type=script&lang=ts"
export * from "./CreateListAction.vue?vue&type=script&lang=ts"
script.render = render

export default script